import { defaultAxios, IParams } from '../base';

export interface IMutateSavePreRequest extends IParams {
  // todo parameter 추가 예정
}

// 주담대 가심사 신청 정보 저장 (confirm)
export const mutateSavePreRequest = async (params: IMutateSavePreRequest) => {
  return await defaultAxios().put(`/house/savePreRequest`, params);
};
